import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../api/api';
import types from '../types';

function reverseGeocodeAPI(lat, lng) {
  return api.post('location/reverseGeocode.php', { lat, lng }, {
    headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  });
}

function locationSearchAPI(query) {
  return api.post('location/reverseGeocode.php', { action: 'autocomplete', query }, {
    headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  });
}

function* handleReverseGeocode(action) {
  try {
    const { lat, lng } = action.payload;
    const response = yield call(reverseGeocodeAPI, lat, lng);
    const address = response.data?.address || `Lat: ${lat.toFixed(4)}, Lng: ${lng.toFixed(4)}`;
    
    yield put({ 
      type: types.REVERSE_GEOCODE_RESPONSE, 
      payload: {
        success: true,
        address,
        location: { lat, lng }
      }
    });
  } catch (error) {
    const { lat, lng } = action.payload;
    const fallbackAddress = `Lat: ${lat.toFixed(4)}, Lng: ${lng.toFixed(4)}`;
    const message = 'Unable to get location suggestions. Please try again.';
    
    
    yield put({ 
      type: types.REVERSE_GEOCODE_RESPONSE, 
      payload: {
        success: false,
        address: fallbackAddress,
        location: { lat, lng },
        error: message
      }
    });
  }
}

function* handleLocationSearch(action) {
  try {
    const { query } = action.payload;
    const response = yield call(locationSearchAPI, query);
    const suggestions = response.data?.suggestions || [];
    
    yield put({ 
      type: types.LOCATION_SEARCH_RESPONSE, 
      payload: {
        success: true,
        suggestions
      }
    });
  } catch (error) {
    const message = 'Unable to get location suggestions. Please try again.';
    
    yield put({ 
      type: types.LOCATION_SEARCH_RESPONSE, 
      payload: {
        success: false,
        suggestions: [],
        error: message
      }
    });
  }
}

export function* reverseGeocodeSaga() {
  yield takeLatest(types.REVERSE_GEOCODE, handleReverseGeocode);
  yield takeLatest(types.LOCATION_SEARCH, handleLocationSearch);
}

export default reverseGeocodeSaga;
